<app-organizer-shared-layout-edit-field
  [title]="'organizer.edit.sport.title' | translate"
  [description]="'organizer.edit.sport.description' | translate"
  [isFormValid]="isFormValid"
  [isFormDirty]="sport.dirty"
  [hasInitialValue]="hasInitialValue"
  [isOverlayDisplayed]="isOverlayDisplayed"
  [overlayStatus]="overlayStatus"
  (submitted)="updateSport()"
>
  <app-form-input-group
    [label]="'a11y.organizer.edit.sport.autcomplete.label' | translate"
    [isHiddenLabel]="true"
    [errors]="sport.errors"
    errorKey="sport"
  >
    <app-form-autocomplete-v2
      #content
      [formControl]="sport"
      [items]="autocompleteSports"
      [placeholder]="'organizer.edit.sport.autcomplete.placeholder' | translate"
      [clearButtonAriaLabel]="
        'a11y.organizer.edit.sport.autcomplete.clear_button' | translate
      "
    ></app-form-autocomplete-v2>
  </app-form-input-group>
</app-organizer-shared-layout-edit-field>
